// People Action Types

// Contact Person Search with Company's id List returned

export const CONTACT_PERSON_SINGLE_COMPANY_SEARCH =
  "CONTACT_PERSON_SINGLE_COMPANY_SEARCH";
export const CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS =
  "CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS";
export const CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE =
  "CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE";

// Create Contact Person

export const CREATE_CONTACT_PERSON = "CREATE_CONTACT_PERSON";
export const CREATE_CONTACT_PERSON_SUCCESS = "CREATE_CONTACT_PERSON_SUCCESS";
export const CREATE_CONTACT_PERSON_FAILURE = "CREATE_CONTACT_PERSON_FAILURE";

// GET_SINGLE_PERSON_CONTACT_DETAILS

export const GET_SINGLE_PERSON_CONTACT_DETAILS =
  "GET_SINGLE_PERSON_CONTACT_DETAILS";
export const GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS =
  "GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS";
export const GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE =
  "GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE";

// Delete Contact Person

export const DELETE_CONTACT_PERSON = "DELETE_CONTACT_PERSON";
export const DELETE_CONTACT_PERSON_SUCCESS = "DELETE_CONTACT_PERSON_SUCCESS";
export const DELETE_CONTACT_PERSON_FAILURE = "DELETE_CONTACT_PERSON_FAILURE";

// Update Contact Person

export const UPDATE_CONTACT_PERSON = "UPDATE_CONTACT_PERSON";
export const UPDATE_CONTACT_PERSON_SUCCESS = "UPDATE_CONTACT_PERSON_SUCCESS";
export const UPDATE_CONTACT_PERSON_FAILURE = "UPDATE_CONTACT_PERSON_FAILURE";

// Delete Contact Person Relationship

export const DELETE_CONTACT_PERSON_RELATIONSHIP =
  "DELETE_CONTACT_PERSON_RELATIONSHIP";
export const DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS =
  "DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS";
export const DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE =
  "DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE";

///contactpersontoemailinbound/search

export const CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH";
export const CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS";
export const CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE";

///contactpersontoemailinbound/data

export const CONTACT_PERSON_TO_EMAIL_INBOUND_DATA =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_DATA";
export const CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS";
export const CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE =
  "CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE";

///contactperson/data/

export const CONTACT_PERSON_DATA = "CONTACT_PERSON_DATA";
export const CONTACT_PERSON_DATA_SUCCESS = "CONTACT_PERSON_DATA_SUCCESS";
export const CONTACT_PERSON_DATA_FAILURE = "CONTACT_PERSON_DATA_FAILURE";

///contactperson/list

export const CONTACT_PERSON_LIST = "CONTACT_PERSON_LIST";
export const CONTACT_PERSON_LIST_SUCCESS = "CONTACT_PERSON_LIST_SUCCESS";
export const CONTACT_PERSON_LIST_FAILURE = "CONTACT_PERSON_LIST_FAILURE";

// search person with customer id

export const SEARCH_PERSON_WITH_CUSTOMER_ID = "SEARCH_PERSON_WITH_CUSTOMER_ID";
export const SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS =
  "SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS";
export const SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE =
  "SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE";

///customertocontactpersonrelationship/search

export const CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH =
  "CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH";
export const CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS =
  "CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS";
export const CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE =
  "CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE";
